export const HOME_HERO_BOUNDARY_ID = "home-hero-boundary"
